"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeNames = void 0;
var themeNames = exports.themeNames = ['im-clarity', 'im-light', 'im-dark', 'im-midnight', 'im-xvantage'];